import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, r = /* @__PURE__ */ t("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15 5H2.659c-1.006 0-1.51 0-1.634-.309-.125-.308.23-.672.941-1.398L4.211 1M1 11h12.341c1.006 0 1.51 0 1.634.309.125.308-.23.672-.941 1.398L11.789 15"
}, null, -1), c = [
  r
];
function s(l, d) {
  return e(), o("svg", n, [...c]);
}
const a = { render: s };
export {
  a as default,
  s as render
};
